import dayjs from "dayjs";
const mobilePattern = /^[6-9]\d{9}$/;
const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.com$/;

export const validateInput = (name, value) => {
  let error = null;
  switch (name) {
    case 'EmpID':
      error = value ? null : "Employee ID is required.";
      break;
    case 'mobile':
      if (!value || value.trim() === '') {
        error = "Phone number is required.";
      } else if (!mobilePattern.test(value)) {
        error = "Phone number must be 10 digits starting with 6-9.";
      }
      break;
    case 'gender':
      error = value ? null : "Gender is required.";
      break;
    case 'alternativeNumber':
      if (value && value.trim() !== '' && !mobilePattern.test(value)) {
        error = "Alternative number must be 10 digits starting with 6-9.";
      }
      break;
    case 'personalEmail':
      if (!value || value.trim() === '') {
        error = "Personal email is required.";
      } else if (!emailPattern.test(value)) {
        error = "Invalid email format. Must end with .com";
      }
      break;
    case 'email':
      if (!value || value.trim() === '') {
        error = "Official email is required.";
      } else if (!emailPattern.test(value)) {
        error = "Invalid email format. Must end with .com";
      }
      break;
    case 'firstname':
      if (!value || value.trim() === '') {
        error = "First name is required.";
      } else if (!/^[A-Za-z\s-]+$/.test(value.trim())) {
        error = "First name should only contain letters, spaces, or hyphens.";
      }
      break;
    case 'lastname':
      if (!value || value.trim() === '') {
        error = "Last name is required.";
      } else if (!/^[A-Za-z\s-]+$/.test(value.trim())) {
        error = "Last name should only contain letters, spaces, or hyphens.";
      }
      break;
    case 'dob': {
      if (!value) {
        error = "Date of Birth is required.";
      } else {
        const enteredDate = dayjs.isDayjs(value) ? value.toDate() : new Date(value);

        if (isNaN(enteredDate.getTime())) {
          error = "Invalid Date of Birth.";
          break;
        }

        const currentDate = new Date();
        let age = currentDate.getFullYear() - enteredDate.getFullYear();

        if (
          currentDate.getMonth() < enteredDate.getMonth() ||
          (currentDate.getMonth() === enteredDate.getMonth() && currentDate.getDate() < enteredDate.getDate())
        ) {
          age--;
        }

        if (age < 20) {
          error = "Employee must be at least 20 years old.";
        } else if (age > 58) {
          error = "Employee age cannot exceed 58 years.";
        }
      }
      break;
    }
    case 'DateOfJoining': {
      if (!value) {
        error = "Date of Joining is required.";
      } else {
        const inputDate = dayjs.isDayjs(value) ? value.toDate() : new Date(value);

        if (isNaN(inputDate.getTime())) {
          error = "Invalid date format.";
          break;
        }

        const oneYearFromTomorrow = new Date();
        oneYearFromTomorrow.setDate(oneYearFromTomorrow.getDate() + 1);
        oneYearFromTomorrow.setFullYear(oneYearFromTomorrow.getFullYear() + 1);
        oneYearFromTomorrow.setHours(0, 0, 0, 0);

        if (inputDate > oneYearFromTomorrow) {
          error = "Date of Joining cannot be more than 1 year in the future.";
        }
      }
      break;
    }
    default:
      break;
  }

  return error;
};
